import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=02b54f6f&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02b54f6f')) {
      api.createRecord('02b54f6f', component.options)
    } else {
      api.reload('02b54f6f', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=02b54f6f&", function () {
      api.rerender('02b54f6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/communityPartyBuilding/swimming/orderCheck/detail.vue"
export default component.exports